import comp from "./AssessmentCategoriesDeleteModal";
export default comp;
